// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__guCv_","tab":"ProcedureTabs_tab__1UP1Y"};